<template>
  <div class="mb-16 px-3">
    <div
      class="d-flex flex-row text-center justify-center justify-md-space-between align-center pa-6"
    >
      <div
        class="d-flex flex-row align-center justify-md-start justify-center fill-width"
      >
        <v-btn
          icon
          v-if="!$vuetify.breakpoint.mobile"
          @click="$router.go(-1)"
          class="mr-3 ml-n3"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <h1>Detalle del cliente</h1>
      </div>
    </div>

    <div class="mb-3">
      <user-card @setContact="setContact" :id="$route.params.id"></user-card>
    </div>

    <v-tabs v-model="tab">
      <v-tab>
        Gestiones
      </v-tab>

      <v-tab>
        Búsquedas
      </v-tab>

      <v-tab>
        Propiedades
      </v-tab>

      <v-tab>
        Impuestos
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <inquiries :owner="owner"></inquiries>
      </v-tab-item>

      <v-tab-item>
        <div class="px-3">
          <v-textarea
            class="mt-3"
            rows="3"
            outlined
            label="Observaciones para búsquedas del cliente"
            v-if="owner"
            hide-details
            v-model="owner.searchObservations"
          ></v-textarea>

          <div class="text-right">
            <v-btn
              class="mt-n14 rounded-tr-0 rounded-bl-0"
              depressed
              @click="editUser"
              :color="success ? 'success' : 'primary'"
              small
            >
              {{
                success ? "observaciones guardadas" : "Guardar observaciones"
              }}
            </v-btn>
          </div>
        </div>

        <v-card tile outlined v-if="searches.length">
          <v-card-text class="d-flex flex-column" style="gap: 12px">
            <div class="d-flex justify-space-between align-end">
              <div>{{ searches.length }} búsqueda(s) asignadas</div>
              <create @reload="fetchSearches"></create>
            </div>

            <template v-for="(search, idx) in searches">
              <search-card
                :search="search"
                :colored="!(idx % 2)"
                @reload="fetchSearches"
              ></search-card>
            </template>
          </v-card-text>
        </v-card>

        <template v-else>
          <v-card outlined tile>
            <v-card-text class="text-center primary--text">
              ¡Parece que este cliente aún no tiene búsquedas! Haz click en
              <create @reload="fetchSearches"></create>
              para crear una búsqueda nueva.
            </v-card-text>
          </v-card>
        </template>
      </v-tab-item>

      <v-tab-item>
        <properties :ownerId="$route.params.id"></properties>
      </v-tab-item>

      <v-tab-item>
        <taxes></taxes>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { Searches } from "@/graphql/queries/searches";
import Taxes from "@/components/directories/Taxes";
import Properties from "@/components/directories/Properties";
import Inquiries from "@/components/directories/Inquiries";
import Create from "@/components/searches/Create";
import SearchCard from "@/components/searches/Card";
import UserCard from "@/components/directories/Card";

import { EditUser } from "@/graphql/mutations/user";

export default {
  data: () => ({
    tab: null,
    owner: null,
    success: false,
    searches: []
  }),

  created() {
    this.fetchSearches();
  },

  methods: {
    fetchSearches() {
      this.$apollo
        .query({
          query: Searches,
          variables: {
            userId: this.$route.params.id
          },
          fetchPolicy: "no-cache"
        })
        .then(res => {
          this.searches = res.data.searches;
        });
    },

    setContact(contact) {
      this.owner = contact;
    },

    editUser() {
      this.$apollo
        .mutate({
          mutation: EditUser,
          variables: {
            input: {
              id: this.owner.id,
              attributes: {
                searchObservations: this.owner.searchObservations
              }
            }
          }
        })
        .then(res => {
          this.success = true;

          setTimeout(() => {
            this.success = false;
          }, 5000);
        });
    }
  },

  components: { Create, Inquiries, Properties, SearchCard, UserCard, Taxes }
};
</script>
